const util = {};

util.inspect = function (value) {
  return value;
};

export default util;
